import Vue from 'vue'
import VueRouter from 'vue-router'

import QrCode from '../views/QrCode'
import InfoForm from '../views/InfoForm'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'qrcode' },
  },
  {
    path: '/qrcode',
    name: 'qrcode',
    component: QrCode,
  },
  {
    path: '/form',
    name: 'form',
    component: InfoForm,
  },
]

const router = new VueRouter({
  routes,
})

export default router
